import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useQuery from 'hooks/useQuery';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import Select from 'v3/components/Select';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import DatePicker from 'v3/components/DatePicker';
import api from 'services/api';

export default function Filter({ onChange }) {
  const query = useQuery();
  const navigate = useNavigate();

  const [provinces, setProvinces] = useState();

  const [filters, setFilters] = useState({});
  const [selectedProvince, setSelectedProvince] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  async function getProvinces() {
    const response = await api.get('provinces');
    const provinceData = response.data.map((item) => ({
      ...item,
      name: item.name,
      id: item.id,
    }));
    setProvinces(provinceData);
  }

  useEffect(() => {
    getProvinces();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({ search: query.toString() });
    }, 150);

    return () => {
      clearTimeout(timeout);
    };
  }, [filters]);

  return (
    <Row className="align-items-end mb-4">
      <Col xs={12} md>
        <Select
          options={provinces}
          placeholder="Selecione um estado"
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={selectedProvince}
          onChange={(value) => {
            if (value === null) {
              query.delete('province');
            } else {
              query.set('province', value.id);
            }
            setFilters((old) => ({ ...old, province: value?.id }));
            setSelectedProvince(value);
          }}
        />
      </Col>
      <Col xs={12} md>
        <DatePicker
          placeholder="Período de"
          value={startDate}
          format="DD/MM/YYYY"
          onChange={(event) => {
            if (event.target.value === null || event.target.value == '') {
              query.delete('first_date');
            } else if (moment(event.target.value, 'DD/MM/YYYY').isValid()) {
              query.set(
                'first_date',
                moment(event.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              );
            }
            setFilters((old) => ({
              ...old,
              first_date: event.target.value,
            }));
            setStartDate(event.target.value);
          }}
        />
      </Col>
      <Col xs={12} md>
        <DatePicker
          value={endDate}
          onChange={(event) => {
            if (event.target.value === null || event.target.value == '') {
              query.delete('end_date');
            } else if (moment(event.target.value, 'DD/MM/YYYY').isValid()) {
              query.set('end_date', moment(event.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD'));
            }
            setFilters((old) => ({ ...old, end_date: event.target.value }));
            setEndDate(event.target.value);
          }}
          placeholder="até"
        />
      </Col>
      <Col xs={12} md="auto" className="d-flex justify-content-end" style={{ marginLeft: 'auto' }}>
        <Button
          variant="success"
          className="w-100"
          onClick={() => {
            onChange();
          }}
        >
          <Text type="regular" weight={500}>
            Filtrar
          </Text>
        </Button>
      </Col>
    </Row>
  );
}
